// extracted by mini-css-extract-plugin
export default {"main":"Gallery_main__omjf5","gallery":"Gallery_gallery__VPh2I","price":"Gallery_price__ji1wY","painting":"Gallery_painting__aIyBc","placeholder":"Gallery_placeholder__a7UdX"};